import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { IdOutskirtBuildings } from "../../../constants/IdOutskirtBuildings";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionAddPelletsInScreenCenterAnimation } from "../../animation/actionPelletAnimations";
import { getResourceIconInfo } from "../../generic/icon/getResourceIconInfo";
import { actionActionButtonResetIteration } from "../../hud-action-button/actionHudActionButton";
import { IdActionButtonEntries } from "../../hud-action-button/IdActionButtonEntries";
import { actionInventoryInfoAddResource } from "../../info/inventory/actionInventoryInfo";
import { actionLimitedActionInfoFetch } from "../../limited-action-info/actionLimitedActionInfo";
export var pathWaterTowerCollectWater = function (action$, state$, deps) {
    return deps
        .netSend({
        id: CommandCode.CollectWater,
        props: {
            playerId: state$.value.playerInfo.playerId,
        },
    })
        .pipe(switchMap(function (res) {
        var products = res.product;
        var productIcons = products.map(function (product) { return getResourceIconInfo(product); });
        return from([
            actionInventoryInfoAddResource(res.product),
            actionLimitedActionInfoFetch(),
            actionAddPelletsInScreenCenterAnimation(IdOutskirtBuildings.Watertower, productIcons),
            actionActionButtonResetIteration(IdActionButtonEntries.WaterTower),
        ]);
    }), retry());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/paths/pathWaterTowerCollectWater.ts
// module id = 2507
// module chunks = 3